'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var fr = {
  code: "fr",
  week: {
    dow: 1,
    doy: 4
  },
  buttonText: {
    prev: "Pr\xE9c\xE9dent",
    next: "Suivant",
    today: "Aujourd'hui",
    year: "Ann\xE9e",
    month: "Mois",
    week: "Semaine",
    day: "Jour",
    list: "Planning"
  },
  weekText: "Sem.",
  allDayText: "Toute la journ\xE9e",
  moreLinkText: "en plus",
  noEventsText: "Aucun \xE9v\xE9nement \xE0 afficher"
};

exports.default = fr;
